import { redirectToUrl } from "~/utils/url/urlUtils";
import { resolveUrl } from "~/utils/url/urlResolver";
import { SEARCHPAGE_BY_DESIGNATION } from "~/utils/url/staticUrls";

export const REDIRECT_TO_PRODUCT = "productCodeOrDesign";

export const setUpLoginPopUp = () => {
  const product = window.SCHA.redirect?.product;
  if (product) {
    window.sessionStorage.setItem(REDIRECT_TO_PRODUCT, product);
  }
};
export const clearRedirectionInfo = () => {
  window.sessionStorage.setItem(REDIRECT_TO_PRODUCT, "");
  if (window.SCHA.redirect) {
    window.SCHA.redirect = { suggestUserSwitch: false, product: "" };
  }
};
export const toBeRedirectedToPdp: () => boolean = () => {
  return !!window.sessionStorage.getItem(REDIRECT_TO_PRODUCT);
};
export const redirectToPdp = () => {
  const productCodeOrDesignation = window.sessionStorage.getItem(REDIRECT_TO_PRODUCT);
  clearRedirectionInfo();
  redirectToUrl(resolveUrl(`/p/${productCodeOrDesignation}`));
};

export const redirectToSrp = () => {
  const productCodeOrDesignation = window.sessionStorage.getItem(REDIRECT_TO_PRODUCT);
  clearRedirectionInfo();
  redirectToUrl(resolveUrl(SEARCHPAGE_BY_DESIGNATION + `?text=${productCodeOrDesignation}&redirect=true`));
};
